document.addEventListener('click', function(e) {

  const nextBtn = e.target.closest('.complementary-arrow-next');
  const prevBtn = e.target.closest('.complementary-arrow-prev');

  if (!nextBtn && !prevBtn) return;

  e.preventDefault();
  e.stopPropagation();

  const section = e.target.closest('.complementary-products');
  if (!section) return;

  const slider = section.querySelector('.list-unstyled');
  if (!slider) return;

  const firstCard = slider.querySelector('li');

  let scrollAmount = 300;

  if (firstCard) {
    scrollAmount = firstCard.getBoundingClientRect().width;
  }

  if (nextBtn) {
    slider.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
  }

  if (prevBtn) {
    slider.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    });
  }

});